import { ADD_PROMO_CODE_ERROR, ADD_PROMO_CODE_REQUEST, ADD_PROMO_CODE_SUCCESS, } from '../types';
import { useHelper } from '../helpers';
export const addPromoCodeRequest = (promoCode) => {
    return {
        type: ADD_PROMO_CODE_REQUEST,
        promoCode,
    };
};
export const addPromoCodeSuccess = (cart, promoCode) => {
    return {
        type: ADD_PROMO_CODE_SUCCESS,
        data: cart,
        promoCode,
    };
};
export const addPromoCodeError = (error, promoCode) => {
    return {
        type: ADD_PROMO_CODE_ERROR,
        error: true,
        payload: error,
        promoCode,
        reason: error?.code,
    };
};
export const addPromoCode = ({ promoCode, }) => {
    return async (dispatch, getState, { chord }) => {
        const { withCart } = useHelper(dispatch, getState);
        dispatch(addPromoCodeRequest(promoCode));
        try {
            await withCart(chord.oms.addCouponCode)(null, promoCode);
            const updatedCart = await withCart(chord.oms.getOrder)();
            dispatch(addPromoCodeSuccess(updatedCart, promoCode));
            return updatedCart;
        }
        catch (error) {
            dispatch(addPromoCodeError(error, promoCode));
            throw error;
        }
    };
};
